import type { ReactNode } from 'react'

import { PopoverStyled } from './style'

interface PopoverProps {
  children?: ReactNode
  id?: string
  open?: boolean
  anchorEl?: null
  onClose?: React.ChangeEventHandler<HTMLFormElement>
}

export const Popover: React.FC<PopoverProps> = ({ children, id, open, anchorEl, onClose }) => {
  return (
    <PopoverStyled
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom',
      }}
      id={id}
      onClose={onClose}
      open={open as boolean}
    >
      {children}
    </PopoverStyled>
  )
}
